import { PartialQueryConfiguration } from '../../people/selections';

export class LinkQueryCriteria extends PartialQueryConfiguration<string> {
  // TODO: string[]
  public propertyName: string;

  constructor() {
    super();
  }
}
